/**
 * Default avatar — a soft photo-portrait silhouette as a data URI.
 *
 * Mirrors the backend `_default_avatar_url()` helper. Replaces the previous
 * cartoon dicebear avatars with a neutral "shadow of a person" framed look.
 * The hue is hashed from the seed so each user gets a stable, unique color
 * without any external network calls.
 */
function hashHue(seed) {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = ((h << 5) - h + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % 360;
}

export function defaultAvatarUrl(seed) {
  const s = seed || "traveler";
  const hue = hashHue(s);
  const sat = 30 + (hashHue(s + "s") % 12);     // 30–42% saturation
  const bg = `hsl(${hue}, ${sat}%, 86%)`;
  const fg = `hsl(${hue}, ${sat + 8}%, 28%)`;
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
    `<rect width="100" height="100" fill="${bg}"/>` +
    `<circle cx="50" cy="38" r="17" fill="${fg}"/>` +
    `<path d="M 14 100 C 14 74 30 64 50 64 C 70 64 86 74 86 100 Z" fill="${fg}"/>` +
    "</svg>";
  return "data:image/svg+xml;utf8," + encodeURIComponent(svg);
}
